<template>
  <v-checkbox
      @click="doFunction"
      @change="onchange"
      :label="itemText"
      :value="itemValue"
      :input-value="value"
      :color="color"
      hide-details
      :disabled="disabled"
  ></v-checkbox>
</template>

<script>
export default {
  name: 'DefaultCheckbox',
  props: {
    itemText: {
      type: [String, Array],
    },
    itemValue: {
      type: [String, Array],
    },
    value: {
      type: [String, Array, Boolean],
    },
    color: {
      type: [String],
      default() {
        return '#FB966E';
      },
    },
    disabled: {
      type: [Boolean],
    },
  },
  methods: {
    onchange(val) {
      this.$emit('input', val, this.selectIndex);
    },

    doFunction() {
      this.$emit('doFunction');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
